import Vue from 'vue'
import Router from 'vue-router'
// import mainContent from '@/components/mainContent'
import Products from '@/views/products/Products'
import successCase from '@/views/successcase/index'
import assetManagement from '@/views/products/components/assetManagement'
import jobHiring from '@/components/jobHiring'
import financeManagement from '@/components/financeManagement'
import aboutUs from '@/components/aboutUs'
import electricity from '@/components/electricity'
import sunshine from '@/components/sunshine'
import bigdata from '@/components/bigdata'
import kingdeestar from '@/components/kingdeestar'
import Cosmic from '@/components/cosmic'
import Galaxy from '@/components/galaxy'
import Jdy from '@/components/jdy'
import CosmicPlatform from '@/components/CosmicPlatform'
import homepage from '@/components/homepage'
import solutions from '@/views/solutions/index'
import solutions1 from '@/views/solutions/components/solutions1'
import manufacture from '@/views/solutions/components/manufacture'
import trade from '@/views/solutions/components/trade'
import traffic from '@/views/solutions/components/traffic'
import medic from '@/views/solutions/components/medic'
import govern from '@/views/solutions/components/govern'
import build from '@/views/solutions/components/build'
import estate from '@/views/solutions/components/estate'
import property from '@/views/solutions/components/property'
import Assets from '@/views/successcase/components/Assets'
import Merchants from '@/views/successcase/components/Merchants'
import Jd from '@/views/successcase/components/Jd'
import Debang from '@/views/successcase/components/Debang'

Vue.use(Router)

const routes =  [
    {
      path: '/',
      name: 'homepage',
      component: homepage,
      meta: {
        title: '苏州睿泽信息技术有限公司'
      }
    },

    {
      path: '/successcase',
      name: 'successCase',
      component: successCase,
      meta: {
        title: '成功案例'
      }
    },
    {
      path: '/successcase/assets',
      name: 'Successcase1',
      component: Assets,
      meta: {
        title: '三资'
      }
    },
    {
      path: '/successcase/merchants',
      name: 'Successcase2',
      component: Merchants,
      meta: {
        title: '招商局'
      }
    }, {
      path: '/successcase/jd',
      name: 'Successcase3',
      component: Jd,
      meta: {
        title: '京东'
      }
    }, {
      path: '/successcase/debang',
      name: 'Successcase4',
      component: Debang,
      meta: {
        title: '德邦物流'
      }
    },
    // {
    //   path: '/asset',
    //   name: 'assetManagement',
    //   component: assetManagement,
    //   meta: {
    //     title: '智慧资管'
    //   }
    // },
    {
      path: '/hiring',
      name: 'jobHiring',
      component: jobHiring,
      meta: {
        title: '公司招聘'
      }
    },
    {
      path: '/finance',
      name: 'financeManagement',
      component: financeManagement,
      meta: {
        title: '智慧财务'
      }
    },

    {
      path: '/products',
      name: 'products',
      component: Products,
      meta: {
        title: '产品中心'
      }
    },
    {
      path: '/assetManagement',
      name: 'assetManagement',
      component: assetManagement,
      meta: {
        title: '智慧资管'
      }
    },
    {
      path: '/electricity',
      name: 'electricity',
      component: electricity,
      meta: {
        title: '智慧电表'
      }
    },
    {
      path: '/sunshine',
      name: 'sunshine',
      component: sunshine,
      meta: {
        title: '阳光村务'
      }
    },
    {
      path: '/bigdata',
      name: 'bigdata',
      component: bigdata,
      meta: {
        title: '云大数据'
      }
    },
    {
      path: '/kingdeestar',
      name: 'Kingdeestar',
      component: kingdeestar,
      meta: {
        title: '金蝶云星辰'
      }
    },
    {
      path: '/cosmic',
      name: 'Cosmic',
      component: Cosmic,
      meta: {
        title: '金蝶云星瀚'
      }
    },
    {
      path: '/galaxy',
      name: 'Galaxy',
      component: Galaxy,
      meta: {
        title: '金蝶云星空'
      }
    },
    {
      path: '/jdy',
      name: 'jdy',
      component: Jdy,
      meta: {
        title: '金蝶精斗云'
      }
    },
    {
      path: '/cosmicPlatform',
      name: 'CosmicPlatform',
      component: CosmicPlatform,
      meta: {
        title: '金蝶云苍穹'
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      meta: {
        title: '关于我们'
      }
    },

    {
      path: '/solutions',
      name: 'solutions',
      component: solutions,
      meta: {
        title: '解决方案'
      }
    },
    {
      path: '/solutions/solutions1',
      name: 'solutions1',
      component: solutions1,
      meta: {
        title: '解决方案'
      }
    },
    {
      path: '/solutions/manufacture',
      name: 'manufacture',
      component: manufacture,
      meta: {
        title: '制造行业'
      }
    },
    {
      path: '/solutions/trade',
      name: 'Trade',
      component: trade,
      meta: {
        title: '批发零售行业'
      }
    },
    {
      path: '/solutions/traffic',
      name: 'Traffic',
      component: traffic,
      meta: {
        title: '交通运输行业'
      }
    },
    {
      path: '/solutions/medic',
      name: 'Medic',
      component: medic,
      meta: {
        title: '医疗健康行业'
      }
    },
    {
      path: '/solutions/govern',
      name: 'Govern',
      component: govern,
      meta: {
        title: '政府公共事业'
      }
    },
    {
      path: '/solutions/build',
      name: 'Build',
      component: build,
      meta: {
        title: '建筑行业'
      }
    },
    {
      path: '/solutions/estate',
      name: 'Estate',
      component: estate,
      meta: {
        title: '建筑行业'
      }
    },
    {
      path: '/solutions/property',
      name: 'Property',
      component: property,
      meta: {
        title: '建筑行业'
      }
    }
  ]

// 路由回到顶部
const router = new Router({
  mode: 'hash',
  routes,
})
// 进入所有页面返回顶部
router.beforeEach((to, from, next) => {
  if(to.meta.title != '苏州睿泽信息技术有限公司'){
    to.meta.title = `${to.meta.title}-苏州睿泽信息技术有限公司`
  }
  next();
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js